module.exports = __webpack_public_path__ + "assets/img/zhenti.6de1e706.png";